module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "top-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("2020年全国啦啦操公开赛")]), _vm._v(" "), _c('van-dropdown-menu', [_c('van-dropdown-item', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('p', {
          staticClass: "dropdown-item-title"
        }, [_vm._v(_vm._s(_vm.option[_vm.value].text))]), _vm._v(" "), _c('p', {
          staticClass: "dropdown-item-time"
        }, [_vm._v(_vm._s(_vm.option[_vm.value].time))])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_vm._v(" "), _vm._l((_vm.option), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          return _vm.dropdownChange1(item)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.time))])])
  })], 2), _vm._v(" "), _c('van-dropdown-item', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('p', {
          staticClass: "dropdown-item-title"
        }, [_vm._v(_vm._s(_vm.option2[_vm.value2].text))]), _vm._v(" "), _c('p', {
          staticClass: "dropdown-item-time"
        }, [_vm._v(_vm._s(_vm.option2[_vm.value2].time))])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, [_vm._v(" "), _vm._l((_vm.option2), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          return _vm.dropdownChange2(item)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.time))])])
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "step-box"
  }, [_c('van-steps', {
    attrs: {
      "direction": "vertical",
      "active": 0
    }
  }, _vm._l((4), function(i) {
    return _c('van-step', {
      key: i
    }, [_c('p', {
      staticClass: "item-team-name"
    }, [_vm._v("广州华怡教育小麒麟啦啦队")]), _vm._v(" "), _c('p', {
      staticClass: "item-team-desc"
    }, [_vm._v("5:21  幼儿组-幼儿组-舞蹈啦啦操-花球规定动作")])])
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-036c5412","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/activity/CompetitionOrder.vue
// module id = 2151
// module chunks = 0